import { Tag } from "antd";
import { TagProps } from "antd/lib";
import React from "react";

/**
 * Converts a string into an array of React elements, alternating between spans and tags.
 *
 * @param string The input string to be converted.
 * @param separator The separator used to split the string.
 * @param props Additional properties to be passed to the Tag component.
 * @returns An array of React elements or null if the input string is empty or undefined.
 */
export function stringToTag(
  string: string | undefined,
  separator: string,
  props: TagProps = {}
): React.ReactElement[] | null {
  if (string === undefined || string === null || string === "") {
    return null;
  }
  const style = props.style ?? {};
  style.margin = 0;
  const splittedString = string.split(separator);
  const contents: React.ReactElement[] = [];
  splittedString.forEach((value, index) => {
    if (index % 2 == 0) contents.push(<span key={index}>{value}</span>);
    else
      contents.push(
        <Tag {...props} key={index} style={style}>
          {value}
        </Tag>
      );
  });

  return contents;
}
